/**
 * Resolve a relative backend URL (e.g. "/api/files/...") to an absolute one
 * that the browser can hit. Leaves absolute URLs untouched.
 */
export function resolveBackendUrl(maybeRelative) {
  if (!maybeRelative) return maybeRelative;
  if (/^(https?:|data:|blob:)/i.test(maybeRelative)) return maybeRelative;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  if (maybeRelative.startsWith("/")) return `${base}${maybeRelative}`;
  return `${base}/${maybeRelative}`;
}
